// Promise Version
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import { MenuItem } from './shared/menu.model';
import { Authentication } from "../authentication/authentication";

@Injectable()
export class MenuService {

    constructor(private auth: Authentication) { }

    // getMenuItems(): Promise<MenuItem[]> {
    //     return new Promise((resolve, reject) => {
    //         this.auth.login()
    //             .then((authenticated: boolean) => {
    //                 if (authenticated) {
    //                     let menuItems: MenuItem[] = JSON.parse(sessionStorage.getItem("userMenu"));
    //                     resolve(menuItems);
    //                 } else {
    //                     resolve(null);
    //                 }
    //             });
    //     });

        getMenuItems(): Promise<MenuItem[]> {
            return new Promise((resolve, reject) => {
               
                        
                            let menuItems: MenuItem[] = JSON.parse(localStorage.getItem("userMenu"));
                            resolve(menuItems);
                        
                
            });
    }
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/menu/menu.service.ts